import React, {useState} from "react";
import PropTypes from 'prop-types';
import TypeEntity from "../EntityExternal/Entity";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import {makeStyles} from "@material-ui/styles";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import request from "../../../../../Services/API/Requests";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../Components/JsonScreen/Utils/lib";

const defaultSelectedOption = {
    option: '',
    object: {}
};

const useStyles = makeStyles(() => ({
    dialogTitle: {
        padding: 5
    },
    dialogActions: {
        padding: 5
    },
    container: {
        padding: 5
    }
}));

const SearchValuePopup = (props) => {
    const {field, onClose, onApply, onCreateNew} = props;
    const [selectedOption, setSelectedOption] = useState(defaultSelectedOption);
    const classes = useStyles();

    async function onSelectOption(option) {
        try {
            const response = await request({
                url: `${field.entity}/read`,
                data: {id: option.value}
            });
            setSelectedOption({
                option: option.value,
                object: response
            })
        } catch (e) {
            console.log(e)
        }
    }

    function onClickApply() {
        onApply(selectedOption.object);
        setTimeout(() => {
            setSelectedOption(defaultSelectedOption)
        }, 500);
    }

    return (
        <Dialog fullWidth maxWidth={"md"} open={props.open} onClose={onClose}>
            <DialogTitle classes={{root: classes.dialogTitle}}>Search</DialogTitle>
            <Divider/>
            <div className={classes.container}>
                <div>
                    <TypeEntity
                        field={{
                            entity: field.entity,
                            label: field.label,
                            path: 'option',
                            schema: field.schema,
                            autofocus: true
                        }}
                        fieldStyles={{
                            width: '450px'
                        }}
                        labelStyles={{
                            width: '100px'
                        }}
                        values={selectedOption}
                        onSelect={onSelectOption}
                    />
                </div>
                <div>
                    {
                        selectedOption.option && (
                            <>
                                <SelectedValues
                                    field={field}
                                    selectedObject={selectedOption.object}
                                />
                            </>
                        )
                    }
                </div>
            </div>
            <Divider/>
            <DialogActions classes={{root: classes.dialogActions}}>
                <Button color={"default"} variant={"contained"} size={"small"} onClick={onClose}>
                    Cancel
                </Button>
                <Button color={"primary"} variant={"contained"} size={"small"} onClick={onClickApply}>
                    Save
                </Button>
                <Button color={"primary"} variant={"outlined"} size={"small"} onClick={onCreateNew}>
                    Create New
                </Button>
            </DialogActions>
        </Dialog>
    )
};
export default SearchValuePopup;

SearchValuePopup.propTypes = {
    globalValues: PropTypes.object,
    field: PropTypes.object,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onApply: PropTypes.func.isRequired,
    onCreateNew: PropTypes.func.isRequired
};

const SelectedValues = (props) => {
    const {field, selectedObject} = props;
    const {userLanguage} = useSelector(state => state.app);
    return (
        <div>
            <Divider style={{margin: '5px 0'}}/>
            {(field.schema ? field.schema.properties : [] || []).map(item => {

                if (item.hidden) return <></>;
                const value = typeof selectedObject[item.name] === 'object' ? '' : selectedObject[item.name];
                return (
                    <div style={{display: 'flex'}}>
                        <div style={{width: 150}}>{multiLanguageValue(item.label, userLanguage)}:</div>
                        <div>{value}</div>
                    </div>
                )
            })}
        </div>
    )
};